export enum ContainerWidth {
  Min = 320,
  Max = 900,
  Default = 600,
  LegacyMin = 0,
}
